import { Button, DialogFooter } from "@material-tailwind/react";
import React, { Component } from "react";
import { FaRegSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

interface FormularHeaderProps {
  onCancel: () => void;
  onSaveDraft: () => void;
  onNext: () => void;
  onPrev: () => void;
  isMaxStep?: boolean;
  isLoading?: boolean;
  isNextDisabled?: boolean;
  isSubmitting?: boolean;
}

const FormularHeader: React.FC<FormularHeaderProps> = ({
  onCancel,
  onSaveDraft,
  onNext,
  onPrev,
  isMaxStep = false,
  isLoading = false,
  isNextDisabled = false,
  isSubmitting = false,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-center w-full justify-between bg-white mt-5 px-4 md:px-0 space-y-4 md:space-y-0">
      <DialogFooter className="flex flex-row space-x-4 md:space-x-10 ml-0 md:ml-5">
        <Button
          onClick={onPrev}
          variant="gradient"
          className="rounded-full bg-[#000000] text-[#FFFFFF] text-sm md:text-base px-3 md:px-4 py-2"
        >
          Précédent
        </Button>
        <Button
          onClick={onCancel}
          variant="outlined"
          className="border rounded-full bg-white text-black text-sm md:text-base px-3 md:px-4 py-2"
        >
          <span className="hidden sm:block">Annuler</span>
          <span className="block sm:hidden" title="Annuler">
            <MdCancel />
          </span>
        </Button>
      </DialogFooter>

      <DialogFooter className="flex flex-row space-x-4 md:space-x-10 mr-0 md:mr-5">
        <Button
          onClick={onSaveDraft}
          variant="outlined"
          className="border-dashed rounded-full bg-[#EFEFEF] text-black text-sm md:text-base px-3 md:px-4 py-2"
        >
          <span className="hidden sm:block">Sauvegarder Brouillon</span>
          <span className="block sm:hidden" title="Sauvegarder Brouillon">
            <FaRegSave />
          </span>
        </Button>

        <Button
          onClick={onNext}
          variant="gradient"
          className="rounded-full bg-[#000000] text-[#FFFFFF] text-sm md:text-base px-3 md:px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isLoading || isNextDisabled || isSubmitting}
        >
          {isLoading || isSubmitting ? (
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>
                {isMaxStep ? "Soumission en cours..." : "Création..."}
              </span>
            </div>
          ) : isMaxStep ? (
            "SOUMETTRE"
          ) : (
            "SUIVANT"
          )}
        </Button>
      </DialogFooter>
    </div>
  );
};

export default FormularHeader;
